import Vue from 'vue';
import { app, store, router } from './index.js';
// import { reportSpeed } from '@utils/report';

import { parseQuery } from '@tencent/slug-function';

// a global mixin that calls `asyncData` when a route component's params change
Vue.mixin({
  beforeRouteUpdate(to, from, next) {
    const { preFetch } = this.$options;
    if (preFetch) {
      console.log('preFetch exce ---------------');
      preFetch(
        store,
        Object.assign(parseQuery(sessionStorage.tokenParams), to.params),
      )
        .then(next)
        .catch(next);
    } else {
      next();
    }
  },
});

// prime the store with server-initialized state.
// the state is determined during SSR and inlined in the page markup.
// eslint-disable-next-line no-underscore-dangle
if (window.__INITIAL_STATE__) {
  // eslint-disable-next-line no-underscore-dangle
  store.replaceState(window.__INITIAL_STATE__);

  // 登录态处理：存入sessionStorage.tokenParams和store.state
  if (location.search.indexOf('msdkEncodeParam') !== -1  || location.search.indexOf('itopencodeparam') !== -1) sessionStorage.tokenParams = location.search;
  // else sessionStorage.tokenParams = ''
  console.log(
    'entry-client设置sessionStorage.tokenParams为',
    sessionStorage.tokenParams,
  );

  // 哈勃性能监控
  // try {
  //   if (performance.timing && performance.timing.navigationStart) {
  //     window.addEventListener(
  //       'load',
  //       () => {
  //         // eslint-disable-next-line no-underscore-dangle
  //         if (!window.__ht) return;
  //         // eslint-disable-next-line no-underscore-dangle
  //         const pt = window.__ht(performance.timing);
  //         setTimeout(() => {
  //           // 首页性能测速
  //           reportSpeed('22400-1-1', {
  //             // 白屏时长
  //             38: pt.responseEnd - pt.navigationStart,
  //             // 首屏时长
  //             39: pt.domContentLoadedEventEnd - pt.navigationStart,
  //             // 用户可操作时长
  //             40: pt.domContentLoadedEventEnd - pt.navigationStart,
  //             // 完全加载时长
  //             41: pt.domComplete - pt.navigationStart,
  //           });
  //         }, 500);
  //       },
  //       false,
  //     );
  //   }
  // } catch (error) {
  //   console.log('哈勃上报error', error);
  // }
}

/**
 * 异步组件
 */
router.onReady(() => {
  // 添加路由钩子函数，用于处理 asyncData.
  // 在初始路由 resolve 后执行，
  // 以便我们不会二次预取(double-fetch)已有的数据。
  // 使用 `router.beforeResolve()`，以便确保所有异步组件都 resolve。

  router.beforeResolve((to, from, next) => {
    const matched = router.getMatchedComponents(to);
    const prevMatched = router.getMatchedComponents(from);
    // 我们只关心之前没有渲染的组件
    // 所以我们对比它们，找出两个匹配列表的差异组件
    let diffed = false;
    const activated = matched.filter((c, i) => diffed || (diffed = prevMatched[i] !== c));
    if (!activated.length) {
      return next();
    }
    // 这里如果有加载指示器(loading indicator)，就触发
    Promise.all(activated.map(component => component.preFetch
          && component.preFetch(
            store,
            Object.assign(
              parseQuery(window.sessionStorage.tokenParams),
              to.params,
            ),
          )))
      .then(() => {
        // 停止加载指示器(loading indicator)
        next();
      })
      .catch(next);
  });

  // 开始挂载到dom上
  window.mountTime = (new Date()).valueOf();
  // app.$mount('#app');
  app.$mount('#app', true);
});

// // service worker
// if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
//   window.navigator.serviceWorker.register('/service-worker.js')
// }
